import React, { useState } from "react";
import { Button, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FabPlateau from "src/components/UiComponents/Buttons/FabPlateau";
import IconButton from "src/components/IconButton";
import { dateFormatter, euroFormatter } from "src/global";
import {
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
  faAdd,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useModal from "src/components/Modal/hooks/useModal";
import ConfirmDeleteDialog from "src/components/Modal/ConfirmDelete";
import EditExtraPriceDialog from "./././EditExtraPriceDialog";
import { showErrorToast, showSuccessToast } from "src/components/Toasts";
import { useEffect } from "react";
import axios from "src/config/axios";
import { useTranslation } from "react-i18next";

const ExtraPricesSettingsPage = ({}) => {
  function handleEdit(extraPrice) {
    setSelectedExtraPrice(extraPrice);
    toggleEdit();
  }

  function handleArchive(extraPrice) {
    setSelectedExtraPrice(extraPrice);
    toggleArchive();
  }

  function handleCreate() {
    setSelectedExtraPrice({});
    toggleEdit();
  }
  const [extraPrices, setExtraPrices] = useState([]);
  const [selectedExtraPrice, setSelectedExtraPrice] = useState({});
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    fetchExtraPrices();
  }, []);

  const fetchExtraPrices = () => {
    axios
      .get(`/api/v1/extra_prices.json`)
      .then(function (response) {
        setExtraPrices(response.data.entries);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const archive = (extraPrice) => {
    axios
      .delete(`/api/v1/extra_prices/${extraPrice.id}.json`)
      .then(function () {
        fetchExtraPrices();
      })
      .catch(function (error) {
        showErrorToast(error.response.data);
      });
  };

  const handleEdited = () => {
    showSuccessToast();
    fetchExtraPrices();
  };

  const handleDelete = () => {
    archive(selectedExtraPrice);
    toggleArchive();
  };

  return (
    <>
      <Card title={`Preise für Extras (${extraPrices.length ?? 0})`}>
        <div className="table-responsive">
          <div className="ui-table-container">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Saison</th>
                  <th>Von</th>
                  <th>Bis</th>
                  <th>Preis</th>
                  <th>Optionen</th>
                </tr>
              </thead>
              <tbody>
                {extraPrices.map((extraPrice) => {
                  return (
                    <tr key={extraPrice.id}>
                      <td>{extraPrice.translated_type_of}</td>

                      <td>
                        {extraPrice.season?.name || (
                          <span className="font-italic"></span>
                        )}
                      </td>

                      <td>
                        {extraPrice.season?.from
                          ? dateFormatter(extraPrice.season.from)
                          : extraPrice.valid_from
                          ? dateFormatter(extraPrice.valid_from)
                          : "-"}
                      </td>

                      <td>
                        {extraPrice.season?.to &&
                          dateFormatter(extraPrice.season.to)}
                      </td>

                      <td>{euroFormatter(extraPrice.price)}</td>

                      <td>
                        <IconButton
                          className="mr-1 bg-transparent border-0 mr-3"
                          textColor="var(--primary)"
                          icon={PencilIcon}
                          onClick={() => handleEdit(extraPrice)}
                        />

                        <IconButton
                          className="mr-2 mr-3 bg-transparent border-0"
                          textColor="var(--danger)"
                          icon={DeleteIcon}
                          onClick={() => handleArchive(extraPrice)}
                        />
                      </td>
                    </tr>
                  );
                })}
                {extraPrices.length === 0 && (
                  <tr>
                    <td>{t("common:components.table.noEntries")}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Row className="justify-content-end mr-2 mt-5">
          <FabPlateau>
            <Button
              className="float-right p-2 pl-3 pr-3"
              variant="primary"
              onClick={handleCreate}
            >
              <FontAwesomeIcon icon={faAdd} />
              {t("common:components.button.new")}
            </Button>
          </FabPlateau>
        </Row>
      </Card>
      <EditExtraPriceDialog
        show={showEdit}
        toggle={toggleEdit}
        extraPrice={selectedExtraPrice}
        handleSuccess={handleEdited}
      />
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default ExtraPricesSettingsPage;
